import type { RouteRecordRaw } from 'vue-router';
import Permission from '@/modules/current-user/permissions/permissions';

export default [
  {
    path: 'threats',
    children: [
      {
        path: '',
        name: 'client-emerging-threats',
        component: () => import('./EmergingThreatsList.vue'),
        meta: {
          permissions: [Permission.ClientsEmergingThreatsView],
        },
      },
      {
        path: ':id',
        name: 'client-emerging-threat',
        component: () => import('./EmergingThreats.vue'),
        props: true,
        redirect: { name: 'client-emerging-threat-dashboard' },
        meta: {
          permissions: [Permission.ClientsEmergingThreatsView],
        },
        children: [
          {
            path: 'suppliers',
            name: 'client-emerging-threat-suppliers',
            component: () => import('./EmergingThreatSuppliersList.vue'),
            props: true,
            meta: {
              permissions: [Permission.ClientsEmergingThreatsView],
            },
          },
          {
            path: 'dashboard',
            name: 'client-emerging-threat-dashboard',
            component: () => import('./EmergingThreatDashboard.vue'),
            props: true,
            meta: {
              permissions: [Permission.ClientsEmergingThreatsView],
            },
          },
        ],
      },
    ],
  },
] satisfies RouteRecordRaw[];
